import { render, staticRenderFns } from "./create_plan.vue?vue&type=template&id=070bf216&scoped=true&"
import script from "./create_plan.vue?vue&type=script&lang=js&"
export * from "./create_plan.vue?vue&type=script&lang=js&"
import style0 from "./create_plan.vue?vue&type=style&index=0&id=070bf216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bf216",
  null
  
)

export default component.exports